import { render } from "./LeaderboardBanner.vue?vue&type=template&id=793fbe58&scoped=true"
import script from "./LeaderboardBanner.vue?vue&type=script&lang=js"
export * from "./LeaderboardBanner.vue?vue&type=script&lang=js"

import "./LeaderboardBanner.vue?vue&type=style&index=0&id=793fbe58&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-793fbe58"]])

export default __exports__